"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomizableFieldSelect = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactResponsiveSelect = _interopRequireDefault(require("react-responsive-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomizableFieldSelect = function CustomizableFieldSelect(_ref) {
  var onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      options = _ref.options,
      name = _ref.name,
      selectedValue = _ref.selectedValue,
      customLabelRenderer = _ref.customLabelRenderer,
      caret = _ref.caret;
  return _react.default.createElement(_reactResponsiveSelect.default, {
    name: name,
    options: options,
    selectedValue: selectedValue,
    onSubmit: onSubmit,
    onChange: onChange,
    caretIcon: caret,
    customLabelRenderer: customLabelRenderer
  });
};

exports.CustomizableFieldSelect = CustomizableFieldSelect;
CustomizableFieldSelect.defaultProps = {
  onSubmit: function onSubmit() {},
  onChange: function onChange() {},
  selectedValue: '',
  customLabelRenderer: function customLabelRenderer() {},
  caret: null
};
CustomizableFieldSelect.propTypes = {
  onSubmit: _propTypes.default.func,
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired,
    markup: _propTypes.default.node,
    disabled: _propTypes.default.bool
  })).isRequired,
  name: _propTypes.default.string.isRequired,
  selectedValue: _propTypes.default.string,
  customLabelRenderer: _propTypes.default.func,
  caret: _propTypes.default.node
};